import type { SVGProps } from 'react';

const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m13.41 12.023 4.29-4.29a.996.996 0 1 0-1.41-1.41L12 10.613l-4.29-4.3a.996.996 0 1 0-1.41 1.41l4.29 4.29-4.29 4.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l4.29-4.29 4.29 4.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-4.29-4.29z"
    />
  </svg>
);
export default SvgClose;
